import styled from '@emotion/styled';

const Container = styled.div<{ isSquare?: boolean }>`
    position: relative;
    background-color: ${({ theme }) => theme.colors.black[20]};
    border-radius: 12px;
    display: flex;
    height: 200px;
    align-items: center;
    justify-content: center;

    ${({ isSquare }) =>
        isSquare &&
        `
    background-size: contain;
`}
`;

const Video = styled.video<{ src: string }>`
    height: 100%;
`;

const ChildrenContainer = styled.div`
    position: absolute;
    bottom: 12px;
    right: 12px;
`;

export const VideoContainer = ({
    src,
    onMouseEnter,
    children,
    isSquare,
}: {
    src: string;
    isSquare?: boolean;
    children: React.ReactNode;
    onMouseEnter: (event: React.MouseEvent<HTMLVideoElement, MouseEvent>) => void;
}) => {
    return (
        <Container isSquare={isSquare}>
            <Video src={src} onMouseEnter={onMouseEnter} autoPlay />
            <ChildrenContainer>{children}</ChildrenContainer>
        </Container>
    );
};
